var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14244 14.2824C11.0873 14.2824 14.2853 11.0844 14.2853 7.13951C14.2853 6.69242 14.2442 6.25493 14.1656 5.8306C13.7413 5.75201 13.3038 5.71094 12.8567 5.71094C8.91183 5.71094 5.71387 8.9089 5.71387 12.8538C5.71387 13.3009 5.75494 13.7384 5.83353 14.1627C6.25786 14.2413 6.69535 14.2824 7.14244 14.2824Z",
    fill: "#175CD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83395 14.1661C2.51417 13.5512 0 10.6407 0 7.14286C0 3.19797 3.19797 0 7.14286 0C10.6407 0 13.5512 2.51417 14.1661 5.83395C13.7417 5.75536 13.3042 5.71428 12.8571 5.71428C8.91225 5.71428 5.71429 8.91225 5.71429 12.8571C5.71429 13.3042 5.75536 13.7417 5.83395 14.1661Z",
    fill: "#1570EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1429 14.2877C11.0878 14.2877 14.2858 11.0897 14.2858 7.14485C14.2858 6.69776 14.2447 6.26027 14.1661 5.83594C17.4859 6.45074 20 9.36133 20 12.8591C20 16.804 16.8021 20.002 12.8572 20.002C9.35938 20.002 6.44879 17.4878 5.83398 14.168C6.25832 14.2466 6.69581 14.2877 7.1429 14.2877Z",
    fill: "#2E90FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany03);
export default __webpack_public_path__ + "static/media/company-03.b7f0869745bb9999f0e6111db56695a9.svg";
export { ForwardRef as ReactComponent };